import { BoxV2 as Box, Flex, Table, useTable } from 'portal-commons';
import { FC } from 'react';
import { faCalendarRange } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import EventsListingRow from './EventsListingRow';
import { getEventHistory } from '../apis';
import { MAX_EVENT_RECORDS } from '../../events/constants';

const headRows = [
  {
    id: 'eventType',
    label: 'EVENT TYPE',
    sortable: false,
  },
  {
    id: 'categoryType',
    label: 'CATEGORY',
    sortable: false,
  },
  {
    id: 'campaignUid',
    label: 'CAMPAIGN ID',
    sortable: false,
  },
  {
    id: 'brandUid',
    label: 'BRAND ID',
    sortable: false,
  },
  {
    id: 'updateDate',
    label: 'DATE & TIME',
    sortable: false,
  },
  {
    id: 'authenticatedUser',
    label: 'USER',
    sortable: false,
  },
  {
    id: 'description',
    label: 'DESCRIPTION',
    sortable: false,
  },
];

interface CampaignEventHistoryProps {
  campaignUid: string;
}

const CampaignEventHistory: FC<CampaignEventHistoryProps> = ({
  campaignUid,
}) => {
  const table = useTable(
    async (filter) => {
      const response = await getEventHistory({
        campaignUid,
        page: filter?.page,
      });

      return {
        data: response?.records || [],
        rowsPerPage: response?.recordsPerPage || 10,
        total: response?.totalRecords || 0,
        page: response?.page || 1,
      };
    },
    {
      deps: [campaignUid],
      inMemory: true,
      cappingTotal: MAX_EVENT_RECORDS,
    }
  );

  return (
    <div
      className="campaign-events details-wrapper"
      data-testid="campaignEventHistory"
    >
      <div className="title">
        <h3 className="heading2">
          <Flex sx={{ alignItems: 'center' }}>
            <Box sx={{ mr: 'xs' }}>
              <FontAwesomeIcon icon={faCalendarRange} />
            </Box>
            <span>Events</span>
          </Flex>
        </h3>
      </div>
      <Table
        testId="campaignEventHistoryTable"
        disableHover
        loading={table.loading}
        headRows={headRows}
        emptyState="no events to view"
        tableData={table.tableData.map((record: any) => {
          return <EventsListingRow key={record.uid} event={record} />;
        })}
        pagination={table.pagination}
        handleChangePage={table.handleChangePage}
        createSortHandler={table.handleSorting}
      />
    </div>
  );
};

export default CampaignEventHistory;
